<template>
  <div :style="cssVars" v-if="selectedOutcome">
    <page-layout :headerBackgroundColor="cssVars['--outcome-primary']">
      <template v-slot:headerContent>
        <div class="row">
          <span
            :style="`color: ${cssVars['--outcome-secondary']}`"
            class="title"
          >
            {{
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : "Test Business"
            }}
          </span>
        </div>
        <div class="row justify-between items-center">
          <div class="row items-center q-mt-sm">
            <span class="dropdownTitle text-white">
              {{ selectedOutcome.label }} Summary
            </span>
            <div class="q-ml-sm">
              <year-picker
                :initial-year="selectedYear"
                ref="yearPicker"
                label="for"
                @selectYear="selectYear"
                :bg="cssVars['--outcome-secondary']"
              ></year-picker>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:content>
        <div class="dataSummary column q-pa-md">
          <div class="col-auto">
            <div class="row">
              <div class="col-auto q-pa-md">
                <h3
                  class="q-mt-none q-mb-xs"
                  :style="`color: ${cssVars['--outcome-secondary']}`"
                >
                  Annual Total
                </h3>
                <h1
                  class="q-my-none"
                  :style="`color: ${cssVars['--outcome-secondary']}`"
                >
                  {{
                    (calculateTotalEmissionsBasedOnData * factorMultiplier)
                      | numberFormat
                  }}
                  <span
                    :style="`font-size: 1rem; font-weight: 400; color: ${cssVars['--outcome-primary']}`"
                  >
                    {{
                      selectedOutcome && selectedOutcome.factorUnitDisplay
                        ? selectedOutcome.factorUnitDisplay
                        : factorUnit
                    }}
                  </span>
                </h1>
                <h3
                  class="q-mb-none q-mt-xl"
                  :style="`color: ${cssVars['--outcome-secondary']}`"
                >
                  {{ selectedOutcome.shortLabel }} Intensity
                </h3>
                <h2
                  class="q-mb-xs q-mt-lg"
                  :style="`color: ${cssVars['--outcome-secondary']}`"
                >
                  {{
                    ((calculateTotalEmissionsBasedOnData * factorMultiplier) /
                      (businessExtra.annualRevenue / 1000000))
                      | numberFormat
                  }}
                  <span
                    :style="`font-size: 0.8rem; font-weight: 400; color: ${cssVars['--outcome-primary']}`"
                  >
                    {{
                      selectedOutcome && selectedOutcome.factorUnitDisplay
                        ? selectedOutcome.factorUnitDisplay
                        : factorUnit
                    }}/$1,000,000
                  </span>
                </h2>
                <p :style="`color: ${cssVars['--outcome-primary']}`">
                  Based on ${{ businessExtra.annualRevenue | numberFormat }}
                  gross revenue
                </p>

                <q-btn
                  class="q-px-sm q-py-xs bg-secondary"
                  label="Back"
                  text-color="white"
                  :style="` position: absolute; bottom: 20px`"
                  no-caps
                  v-if="selectedOutcome.emissionCalculator == 1"
                  flat
                  @click="
                    $router.push(
                      `${
                        $route.path.split('dataSummary')[0]
                      }emissionCalculator${$route.path.split('dataSummary')[1]}`
                    )
                  "
                >
                </q-btn>
                <q-btn
                  class="q-px-sm q-py-xs bg-secondary"
                  label="Back"
                  text-color="white"
                  :style="` position: absolute; bottom: 20px`"
                  no-caps
                  v-else
                  flat
                  @click="
                    $router.push(
                      `${$route.path.split('dataSummary')[0]}dataUpload${
                        $route.path.split('dataSummary')[1]
                      }`
                    )
                  "
                >
                </q-btn>
              </div>
              <!-- <div > -->
              <q-scroll-area
                :thumb-style="{
                  background: '#162c479c',
                  opacity: 1,
                  width: '8px',
                  height: '8px',
                  borderRadius: '20px',
                }"
                class="col q-pa-md"
                style="height: calc(100vh - 202px)"
              >
                <div class="row q-mb-sm">
                  <div class="col-12">
                    <h5
                      class="q-my-xs"
                      :style="`color: ${cssVars['--outcome-secondary']}`"
                    >
                      Category Breakdown
                    </h5>
                  </div>
                  <div
                    class="col-12"
                    style="height: calc(100vh - 340px); max-height: 400px"
                  >
                    <apex-chart
                      :ref="`chart`"
                      height="100%"
                      :options="chartOptions"
                      :series="
                        categoryBreakdown.length > 0
                          ? [{ data: categoryBreakdown }]
                          : []
                      "
                      :resizeChecking="true"
                    >
                    </apex-chart>
                  </div>
                </div>
                <div class="row q-mb-sm">
                  <div class="col-12">
                    <h5
                      class="q-my-sm"
                      :style="`color: ${cssVars['--outcome-secondary']}`"
                    >
                      Source Breakdown
                    </h5>
                  </div>
                </div>
                <div
                  class="row q-py-sm"
                  v-for="(category, index) in categoryBreakdown"
                  :key="`category_${index}`"
                >
                  <div class="col">
                    <h6 class="q-my-xs text-accent">{{ category.x }}</h6>
                  </div>
                  <div class="col-auto">
                    <h6
                      class="q-my-xs text-accent"
                      :style="`width: 120px; `"
                    ></h6>
                  </div>
                  <div class="col-auto">
                    <h6 class="q-my-xs text-accent" :style="`width: 130px; `">
                      {{ factorCalculation(category.y) | numberFormat }}
                      {{ factorUnitCalc(category.unit) }}
                    </h6>
                  </div>
                  <div class="col-auto">
                    <h6 class="q-my-xs text-accent" :style="`width: 130px; `">
                      {{
                        Math.round(
                          (category.y / calculateTotalEmissionsBasedOnData) *
                            100
                        )
                      }}% of total {{ factorUnitCalc(category.unit) }}
                    </h6>
                  </div>
                  <div
                    v-for="(source, sIndex) in category.sources"
                    :key="`source_${source.sources_id}`"
                    class="row full-width q-py-xs"
                  >
                    <div class="col">
                      <p class="q-my-xs text-accent">
                        {{ source.name }}
                        {{
                          source.negativeLabel && source.negative
                            ? `(${source.negativeLabel})`
                            : source.positiveLabel && !source.negative
                            ? `(${source.positiveLabel})`
                            : ""
                        }}
                      </p>
                    </div>
                    <div class="col-auto">
                      <p class="q-my-xs text-accent" :style="`width: 120px; `">
                        {{ source.total ? source.total : 0 | numberFormat }}
                        {{ source.unit }}
                      </p>
                    </div>
                    <div class="col-auto">
                      <p class="q-my-xs text-accent" :style="`width: 130px; `">
                        <!-- Custom Data -->
                        <span
                          v-if="
                            source.customEmissionsFactor &&
                            source.customEmissionsFactor.useCustom
                          "
                        >
                          {{
                            factorCalculation(
                              source.customEmissionsFactor.totalValue
                            ) | numberFormat
                          }}
                        </span>

                        <!-- Manual Data -->
                        <span v-else>
                          {{
                            factorCalculation(getSourceFactoredAmount(source))
                              | numberFormat
                          }}
                        </span>
                        {{ factorUnitCalc(category.unit) }}
                      </p>
                    </div>
                    <div class="col-auto">
                      <p class="q-my-xs text-accent" :style="`width: 130px; `">
                        <span
                          v-if="
                            source.customEmissionsFactor &&
                            source.customEmissionsFactor.useCustom
                          "
                        >
                          {{
                            Math.round(
                              (source.customEmissionsFactor.totalValue /
                                calculateTotalEmissionsBasedOnData) *
                                100
                            )
                          }}
                        </span>
                        <span v-else>
                          {{
                            Math.round(
                              (getSourceFactoredAmount(source) /
                                calculateTotalEmissionsBasedOnData) *
                                100
                            )
                          }}
                        </span>
                        % of total {{ factorUnitCalc(category.unit) }}
                      </p>
                    </div>
                  </div>
                </div>
              </q-scroll-area>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:sideBarContent>
        <div class="column full-height full-width sidebar">
          <div class="col-auto q-py-md q-px-lg" style="height: calc(109px)">
            <div class="row full-height items-center">
              <span class="title">
                {{ selectedData ? "Summary" : "Outcome Summary" }}
              </span>
            </div>
          </div>
          <div class="col-auto q-pa-lg" style="height: calc(100vh - 226px)">
            <div v-if="selectedData">
              <div>
                <div class="row">
                  <div class="col-12">
                    <h3 class="sourceName text-accent q-my-md">
                      {{ selectedData.x }} <br />
                      makes up
                    </h3>
                  </div>
                  <div class="col-12">
                    <h2
                      class="q-my-md"
                      :style="`color: ${cssVars['--outcome-primary']}`"
                    >
                      {{
                        Math.round(
                          (selectedData.y /
                            calculateTotalEmissionsBasedOnData) *
                            100
                        )
                      }}%
                    </h2>
                    <h3>
                      of your
                      {{
                        selectedOutcome && selectedOutcome.factorUnitDisplay
                          ? selectedOutcome.factorUnitDisplay
                          : selectedData.unit
                      }}
                      in {{ selectedYear }}
                    </h3>
                  </div>
                  <div class="col-12">
                    <p>which equates to</p>
                  </div>
                  <div class="col-12">
                    <h2
                      class="q-my-md"
                      :style="`color: ${cssVars['--outcome-primary']}`"
                    >
                      {{ factorCalculation(selectedData.y) | numberFormat }}
                      {{ factorUnitCalc(selectedData.unit) }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="q-mt-lg">
              Welcome to your
              <b class="highlight">{{ selectedOutcome.label }} Summary</b>, this
              reveals a breakdown of the categories and sources of this outcome
              for the data you’ve entered.
            </div>
          </div>
          <div class="col q-px-md text-right">
            <q-btn
              @click="goToAssessmentToolEditor"
              class="q-px-sm q-py-xs bg-accent col-auto q-mr-sm"
              no-caps
              flat
            >
              <span class="text-white text"> Another Tool </span>
            </q-btn>
            <q-btn
              @click="
                $router.push(
                  `${$route.path.split('dataSummary')[0]}goalSummary${
                    $route.path.split('dataSummary')[1]
                  }`
                )
              "
              class="q-px-sm q-py-xs col-auto"
              :style="`background: ${cssVars['--outcome-secondary']}`"
              no-caps
              flat
            >
              <span class="text-white text"> Next </span>
            </q-btn>
          </div>
        </div>
      </template>
    </page-layout>
    <q-dialog v-model="emissionFactorDialog" persistent>
      <custom-emission-factor-dialog
        @closeDialog="closeEmissionsFactorDialog"
        :outcomeStyle="cssVars"
      ></custom-emission-factor-dialog>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageLayout from "@/components/pageLayout/pageLayout.vue";
import YearPicker from "@/components/generalComponents/yearPicker.vue";
import SustainabilityDataTable from "@/components/datatable/sustainabilityDatatable.vue";
import { getMonths } from "@/functions/getMonths";
import customEmissionFactorDialog from "@/components/customEmissionFactorDialog/customEmissionFactorDialog.vue";
import apexChart from "@/components/wrappers/apexCharts/apexChart.vue";

export default {
  components: {
    PageLayout,
    YearPicker,
    SustainabilityDataTable,
    customEmissionFactorDialog,
    apexChart,
  },
  mounted() {
    this.init();
    this.handleRoute();
    this.initCategoryBreakdown();
  },
  watch: {
    $route: {
      handler(value) {
        this.handleRoute();
      },
      deep: true,
    },
    data: function () {
      this.initCategoryBreakdown();
    },
    selectedOutcome: function () {
      this.init();
    },
  },
  computed: {
    ...mapGetters({
      outcomesList: "outcomes/list",
      currentUserData: "auth/currentUserData",
      outcomesCategories: "outcomes/categories/listForData",
      businessExtra: "businessExtra/data",
      data: "sources/data/list",
      selectedOutcome: "businessOutcomePlans/selectedOutcome",
    }),
    chartOptions() {
      return {
        chart: {
          type: "treemap",
          id: "areachart-2",
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.selectedData = this.categoryBreakdown[config.dataPointIndex];
            },
          },
        },
        colors: [this.cssVars["--outcome-secondary"]],
        yaxis: {
          labels: {
            formatter: (val) => {
              return `${this.$options.filters.numberFormat(
                this.factorCalculation(val)
              )}`;
            },
          },
        },
      };
    },
    calculateTotalEmissionsBasedOnData() {
      let totalEmissions = 0;
      if (this.filteredData.length > 0) {
        this.filteredData.forEach((e) => {
          if (!e.external && e.emissionsFactor.length > 0) {
            totalEmissions += this.getTotalDefaultEmission(e);
          } else if (e.external && e.customEmissionsFactor) {
            if (!isNaN(parseFloat(e.customEmissionsFactor.totalValue))) {
              totalEmissions += parseFloat(e.customEmissionsFactor.totalValue);
            }
          }
        });
      }
      return totalEmissions;
    },
    cssVars() {
      let primaryColorFaded = this.selectedOutcome.primaryColor
        ? this.selectedOutcome.primaryColor.split("#")
        : ["", "162c47"];
      let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";

      return {
        "--outcome-primary": this.selectedOutcome.primaryColor
          ? this.selectedOutcome.primaryColor
          : "#162c47",
        "--outcome-secondary": this.selectedOutcome.secondaryColor
          ? this.selectedOutcome.secondaryColor
          : "#162c47",
        "--outcome-tertiary": this.selectedOutcome.tertiaryColor
          ? this.selectedOutcome.tertiaryColor
          : "#162c47",
        "--outcome-primary-faded": primaryColorFadedString,
      };
    },
  },
  data: () => ({
    selectedCategory: "all",
    filteredData: [],
    selectedSource: null,
    emissionFactorDialog: false,
    sortBy: null,
    sortByOptions: ["High", "Low"],
    selectedYear: null,

    categoryBreakdown: {},

    selectedCategorySummary: null,

    factorUnit: "",

    selectedData: null,

    factorMultiplier: 1,
  }),

  methods: {
    getMonths: getMonths,
    initCategoryBreakdown() {
      let categoryData = {};

      this.data.forEach((source) => {
        if (source.total) {
          if (!categoryData[source.categories_id]) {
            categoryData[source.categories_id] = {
              sources: [],
              unit:
                source.emissionsFactor.length < 1 &&
                source.customEmissionsFactor
                  ? source.unit
                  : source.emissionsFactor[0].unit,
              y: 0,
              x: source.categoryName,
            };

            if (source.emissionsFactor.length > 0) {
              this.factorUnit = source.emissionsFactor[0].unit;
            }
          }

          if (
            (!source.customEmissionsFactor ||
              !source.customEmissionsFactor.useCustom) &&
            source.emissionsFactor.length > 0
          ) {
            categoryData[source.categories_id].y +=
              this.getTotalDefaultEmission(source);
          } else if (
            source.customEmissionsFactor &&
            source.customEmissionsFactor.useCustom
          ) {
            if (!isNaN(parseFloat(source.customEmissionsFactor.totalValue))) {
              categoryData[source.categories_id].y += parseFloat(
                source.customEmissionsFactor.totalValue
              );
            }
          }

          categoryData[source.categories_id].sources.push(source);
        }
      });

      this.categoryBreakdown = Object.values(categoryData).sort((a, b) => {
        return b.y - a.y;
      });
    },

    selectYear(val) {
      this.selectedYear = val.split("/")[0];
      this.$router.push(
        `${this.$route.path.split("/year")[0]}/year/${this.selectedYear}`
      );
      this.$store
        .dispatch("sources/data/loadAllByOutcomesIDAndYearWithGoals", {
          id: this.selectedOutcome.id,
          year: this.selectedYear,
        })
        .then((e) => {
          this.filterData();
        });
    },
    isSelected(row, selectedArray) {
      let index = selectedArray.findIndex((e) => e.id == row.id);
      if (index > -1) {
        return true;
      } else {
        return false;
      }
    },
    sortListByCarbonEmissions() {
      let formattedList = this.filteredData.map((e) => {
        let formattedData = { ...e };
        if (formattedData.customEmissionsFactor) {
          if (formattedData.customEmissionsFactor.useCustom) {
            formattedData["emissionsSort"] = parseFloat(
              formattedData.customEmissionsFactor.totalValue
            );
          } else {
            formattedData["emissionsSort"] = null;
          }
        } else if (formattedData.emissionsFactor.length > 0) {
          let defaultEmissionValue = this.getCustomTotalEmission(
            formattedData.total,
            formattedData
          );
          formattedData["emissionsSort"] = parseFloat(defaultEmissionValue);
        } else {
          formattedData["emissionsSort"] = null;
        }

        return formattedData;
      });

      if (this.sortBy == "High") {
        this.filteredData = formattedList.sort((a, b) =>
          a.emissionsSort < b.emissionsSort ? 1 : -1
        );
      } else if (this.sortBy == "Low") {
        this.filteredData = formattedList.sort((a, b) =>
          a.emissionsSort > b.emissionsSort ? 1 : -1
        );
      }
      this.$forceUpdate();
    },
    closeEmissionsFactorDialog() {
      this.$router.push(
        `${this.$route.path.split("dataSummary")[0]}emissionCalculator`
      );
      this.emissionFactorDialog = false;
    },
    handleRoute() {
      if (
        this.$route.params.hasOwnProperty("sourceId") &&
        this.$route.params.hasOwnProperty("year")
      ) {
        this.emissionFactorDialog = true;
      }
    },
    onDoubleClick(data) {
      this.$router.push(
        this.$route.path +
          "/" +
          this.$refs.yearPicker.selectedYear +
          "/" +
          data.sources_id
      );
    },
    filterCategory(category) {
      this.selectedCategory = category;
      this.filterData();
    },
    selectData(data) {
      this.selectedSource = data;
    },
    getLatestFactorToTheSelectedYear(data) {
      let selectedYear =
        typeof this.$refs.yearPicker.selectedYear == "number"
          ? this.$refs.yearPicker.selectedYear
          : parseFloat(this.$refs.yearPicker.selectedYear.split("/")[0]);
      if (data.emissionsFactor.length > 0) {
        let latestEmissionFactor = data.emissionsFactor[0];
        data.emissionsFactor.forEach((e) => {
          if (parseFloat(e.created_at.split("-")[0]) <= selectedYear) {
            latestEmissionFactor = { ...e };
          }
        });
        return latestEmissionFactor;
      } else {
        return null;
      }
    },
    checkUrl(url) {
      if (!url.includes("http")) {
        return "https://" + url;
      } else {
        return url;
      }
    },
    getCustomTotalEmission(totalValue, data) {
      let latestEmissionFactor = this.getLatestFactorToTheSelectedYear(data);
      if (latestEmissionFactor) {
        if (latestEmissionFactor.unit.toLowerCase() == "kgco2-e") {
          return (
            (parseFloat(totalValue) *
              parseFloat(latestEmissionFactor.emissionsFactor)) /
            1000
          );
        } else {
          return (
            parseFloat(totalValue) *
            parseFloat(latestEmissionFactor.emissionsFactor)
          );
        }
      } else {
        return null;
      }
    },
    getTotalDefaultEmission(data) {
      //get the chosen year
      let selectedYear =
        typeof this.$refs.yearPicker.selectedYear == "number"
          ? this.$refs.yearPicker.selectedYear
          : parseFloat(this.$refs.yearPicker.selectedYear.split("/")[0]);

      if (data.emissionsFactor.length > 0) {
        //get the latest emissions factor of the selected year
        let latestEmissionFactor = data.emissionsFactor[0];
        data.emissionsFactor.forEach((e) => {
          if (parseFloat(e.created_at.split("-")[0]) <= selectedYear) {
            latestEmissionFactor = { ...e };
          }
        });

        if (latestEmissionFactor.unit.toLowerCase() == "kgco2-e") {
          return (
            (parseFloat(data.total) *
              parseFloat(latestEmissionFactor.emissionsFactor)) /
            1000
          );
        } else {
          return (
            parseFloat(data.total) *
            parseFloat(latestEmissionFactor.emissionsFactor)
          );
        }
      }
    },
    filterData() {
      let currentData = this.data;
      currentData = currentData.filter((e) => e.total);
      currentData = currentData
        .filter((e) => {
          if (this.selectedCategory == "all") {
            return e;
          } else {
            if (e.categories_id == this.selectedCategory.id) {
              return e;
            }
          }
        })
        .sort((a, b) => (a.rank > b.rank ? 1 : -1));
      currentData = currentData.map((e) => {
        if (this.isUseCustomEmissionsFactor(e)) {
          return { ...e, external: true };
        } else {
          return { ...e, external: false };
        }
      });
      this.filteredData = currentData;
      this.sortListByCarbonEmissions();
    },
    isUseCustomEmissionsFactor(row) {
      if (row.customEmissionsFactor) {
        if (row.customEmissionsFactor.useCustom) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    init() {
      this.selectedYear = this.$route.params.year
        ? this.$route.params.year
        : this.$moment().format("YYYY");
      if (this.selectedOutcome) {
        this.$store.dispatch(
          "outcomes/categories/loadAllByOutcomesID",
          this.selectedOutcome.id
        );
        this.$store
          .dispatch("sources/data/loadAllByOutcomesIDAndYearWithGoals", {
            id: this.selectedOutcome.id,
            year: this.selectedYear,
          })
          .then((e) => {
            this.filterData();
          });
        this.factorMultiplier = this.selectedOutcome.factorMultiplier
          ? this.selectedOutcome.factorMultiplier
          : 1;
      }
      // this.$store.dispatch("outcomes/loadAll").then((e) => {
      //   if (this.outcomesList.length > 0) {
      //     this.tab = this.outcomesList[0].name;
      //     if (this.$route.params.hasOwnProperty("outcomesID")) {
      //       let index = this.outcomesList.findIndex(
      //         (o) => this.$route.params.outcomesID == o.id
      //       );
      //
      //       this.selectedOutcome = this.outcomesList[index];
      //     } else {
      //       this.selectedOutcome = this.outcomesList[0];
      //     }
      //
      //     this.$store.dispatch(
      //       "outcomes/categories/loadAllByOutcomesID",
      //       this.selectedOutcome.id
      //     );
      //     this.$store
      //       .dispatch("sources/data/loadAllByOutcomesIDAndYearWithGoals", {
      //         id: this.selectedOutcome.id,
      //         year: this.selectedYear,
      //       })
      //       .then((e) => {
      //         this.filterData();
      //       });
      //   }
      // });
    },

    getSourceFactoredAmount(source) {
      if (!source.external && source.emissionsFactor.length > 0) {
        return this.getTotalDefaultEmission(source);
      } else if (source.external && source.customEmissionsFactor) {
        if (!isNaN(parseFloat(source.customEmissionsFactor.totalValue))) {
          return this.parseFloat(source.customEmissionsFactor.totalValue);
        }
      } else {
        return source.total;
      }
    },

    goToAssessmentToolEditor() {
      this.$router.push(
        `${this.$route.path.split("dataSummary")[0]}chooseAssessmentTool`
      );
    },
    factorCalculation(data) {
      if (
        this.selectedOutcome &&
        this.selectedOutcome.factorMultiplier &&
        data
      ) {
        return data * this.selectedOutcome.factorMultiplier;
      } else {
        return data;
      }
    },
    factorUnitCalc(data) {
      if (this.selectedOutcome && this.selectedOutcome.factorUnitDisplay) {
        return this.selectedOutcome.factorUnitDisplay;
      } else {
        return data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/*topbar */
.title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
}

.dropdownTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
}

.sidebar {
  background-color: #f6f6f6;

  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 800;
    font-size: 20px;
    color: var(--outcome-secondary);
  }

  h2 {
    font-size: 2.4rem;
    line-height: 2.6rem;
    font-weight: 900;
  }

  h3 {
    font-size: 1.4rem;
    line-height: 1.6rem;
    font-weight: 900;
    color: $accent2;
  }

  p {
    font-size: 1rem;
    color: $accent2;
    font-weight: 900;
  }
}

.dataSummary {
  h1 {
    font-weight: 900;
    font-size: 3rem;
    line-height: 3.1rem;
  }

  h5 {
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 1.3rem;
  }

  h2 {
    font-size: 2rem;
    font-weight: 800;
    line-height: 2.1rem;
  }

  h3 {
    font-size: 1.3rem;
    font-weight: 700;
    line-height: 1.6rem;
  }

  h6 {
    font-weight: 600;
    font-size: 0.8rem;
    line-height: 1rem;
  }

  p {
  }
}
</style>
